import './style.css';
import { daysToMs, hoursToMs, minutesToMs, secondsToMs } from '../../constants';

const delta = 24 * hoursToMs;

/**
 * calculate time str
 * @param diff
 * @return {string}
 */
const calculateTimeStr = (diff) => {
  //also count up if final date in the past (diff < 0)
  //use delta to show gratulation for 1 day
  const localDiff = diff < 0 ? (diff > -delta ? 0 : -diff) : diff;

  if (localDiff !== 0) {
    const days = Math.floor(localDiff / daysToMs);
    let rest = localDiff - days * daysToMs;
    const hours = Math.floor(rest / hoursToMs);
    rest -= hours * hoursToMs;
    const minutes = Math.floor(rest / minutesToMs);
    rest -= minutes * minutesToMs;
    const seconds = Math.round(rest / secondsToMs);

    const dayStr = `${days.toString().padStart(2, '0')} Tage`;
    const hourStr = `${hours.toString().padStart(2, '0')} Stunden`;
    const minStr = `${minutes.toString().padStart(2, '0')} Minuten`;
    const secStr = `${seconds.toString().padStart(2, '0')} Sekunden`;

    if (days > 0) {
      const firstPart = `${dayStr}, ${hourStr}`;
      const secondPart = `${minStr}, ${secStr}`;
      return [firstPart, secondPart];
    }

    if (hours > 0) {
      const firstPart = `${hourStr}`;
      const secondPart = `${minStr}, ${secStr}`;
      return [firstPart, secondPart];
      // return `${hourStr}, ${minStr}, ${secStr}`;
    }
    if (minutes > 0) {
      const firstPart = ``;
      const secondPart = `${minStr}, ${secStr}`;
      return [firstPart, secondPart];
      // return `${minStr}, ${secStr}`;
    }
    if (seconds > 0) {
      const firstPart = ``;
      const secondPart = `${secStr}`;
      return [firstPart, secondPart];
      // return `${secStr}`;
    }
  }
  return ['Herzlichen', 'Glückwunsch'];
};

function Countdown(props) {
  const { diff } = props;
  const [firstPart, secondPart] = calculateTimeStr(diff);

  return (
    <div className="counter-container">
      <span className="counter-string">{firstPart}</span>
      <span className="counter-string">{secondPart}</span>
    </div>
  );
}

export default Countdown;
